import React from 'react';
import Modal from 'components/shared/Modal/Modal';
import classnames from 'classnames';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import './CommissionErrorBox.css';

const CommissionErrorBox = (props) => {
  return (
    <Modal animateX={false} close={() => props.onClose()} noPadding height={266} width={480}>
      <div className="Commission_ErrorBox_Container">
        <div className="Commission_ErrorBox_TopContainer">
          <div className={'Commission_ErrorBox_HeaderText'} data-tip={props.title}>
            {props.title}
          </div>
          <div className="Commission_ErrorBox_MessageText" data-tip={props.message}>
            {props.message}
          </div>
        </div>
        <div className="Commission_ErrorBox_BottomContainer">
          <button
            className="Commission_ErrorBox_Bottom_CancelButton"
            onClick={() => {
              props.onClose();
            }}
          >
            Close
          </button>
          {props.action && (
            <button
              type="submit"
              disabled={props.isFetching && props.isFetching}
              className={classnames({
                Commission_ErrorBox_Bottom_ActionButton: true
                // Commission_ErrorBox_Bottom_ActionButton_Disabled: nameInputError !== '' || deviceIdsValid()
              })}
              onClick={() => {
                props.action();
              }}
            >
              {props.isFetching ? BUTTON_LOADING_CIRCLE : 'Retry'}
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CommissionErrorBox;
